(function ($) {
  Drupal.behaviors.productsStickyNav = {
    attach: function (context) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      var $mppContainer = $('.js-mpp-container', context);
      var $mppStickyNavContainer = $('.js-products-sticky-nav', context);

      function _processMppStickyNav() {
        var navHeaderHeight = 0;
        var processStickyHeader = true;
        var startPos = $mppContainer.offset().top;
        var currentPos = $(window).scrollTop();

        if ($mppStickyNavContainer.data('isSticky')) {
          if (
            (processStickyHeader &&
              $('body').hasClass('site-header-formatter--sticky') &&
              !$('body').hasClass('site-header-formatter--hidden')) ||
            $('.js-products-sticky-nav').hasClass('sticky')
          ) {
            // If the header is sticky we need to use it in the startPos check
            if (
              $('body').hasClass('site-header-formatter--sticky') &&
              !$('body').hasClass('site-header-formatter--hidden')
            ) {
              navHeaderHeight += $('.js-nav-header-container').outerHeight(true);
            }
            startPos -= navHeaderHeight;
            processStickyHeader = false;
          }
          currentPos = $(window).scrollTop();
          if (currentPos >= startPos) {
            $mppStickyNavContainer.addClass('sticky');
          } else {
            $mppStickyNavContainer.removeClass('sticky');
          }
        } else {
          $mppStickyNavContainer.removeClass('sticky');
        }
      }

      function getNavHeight(currentTopLink) {
        var curPos = $(this).scrollTop();
        var $nav = $('.js-products-sticky-nav__links', context);
        var navHeight = $nav.outerHeight(true);
        var gnavHeight = $('.js-site-header-formatter__header').outerHeight(true) - 20;
        if (currentTopLink > curPos) {
          gnavHeight = 0;
        }
        navHeight += gnavHeight;
        return navHeight;
      }

      function highlightActive() {
        var $sections = $('.anchored-item', context);
        var $nav = $('.js-products-sticky-nav__links', context);
        var navHeight = $nav.height();
        var $navLinks = $nav.find('a');
        var firstLinkHash = $nav.find('a:first').attr('href').split('#');
        var firstId = firstLinkHash[1];

        $navLinks.first().addClass('active');

        $(window).on(
          'scroll',
          _.throttle(function () {
            var curPos = $(this).scrollTop();

            $sections.each(function () {
              var $this = $(this);
              var $anchorElement = $this.find('.supercat_product_layout__anchor');
              var currentTopLink = $this.offset().top;
              var highlightBuffer = 200;
              var top = currentTopLink - (navHeight + highlightBuffer);
              var bottom = top + $this.height();
              var $eachAnchor = $(
                'a[href="' + window.location.pathname + '#' + $anchorElement.attr('id') + '"]',
                context
              );

              if (curPos >= top && curPos <= bottom) {
                $navLinks.removeClass('active');
                $sections.removeClass('active');
                $this.addClass('active');
                $nav.find($eachAnchor).addClass('active');
              } else if (curPos == 0) {
                $navLinks.removeClass('active');
                $navLinks.first().addClass('active');
              }
            });
          }, 500)
        );

        $navLinks.once().on('click', function (context) {
          var $el = $(this);
          var urlHash = $el.attr('href').split('#');
          var id = urlHash[1];
          var currentTopLink = $('#' + id).offset().top;
          var currentTopValue = currentTopLink - getNavHeight(currentTopLink);

          if (id === firstId) {
            $('html, body').animate(
              {
                scrollTop: 0
              },
              500
            );
            $mppStickyNavContainer.removeClass('sticky');
          } else {
            $('html, body').animate(
              {
                scrollTop: currentTopValue
              },
              500,
              'linear'
            );
          }
          return false;
        });
      }

      function productCount(context) {
        var productNumber = $('.js-sticky-nav__level--count-number', context);
        var n = $('.js-product-brief', context).length;
        var $productSuffix = $('.js-sticky-nav-count-product-suffix', context);
        var $productsSuffix = $('.js-sticky-nav-count-products-suffix', context);

        productNumber.append(n);

        if (n > 1) {
          $productSuffix.addClass('hidden');
          $productsSuffix.removeClass('hidden');
        } else {
          $productSuffix.removeClass('hidden');
          $productsSuffix.addClass('hidden');
        }
      }

      function setEvents() {
        Unison.on('change', function () {
          _processMppStickyNav();
        });

        $(window).on(
          'scroll',
          _.debounce(function () {
            _processMppStickyNav();
          }, 50)
        );
      }
      highlightActive();
      productCount();
      setEvents();
    }
  };
})(jQuery);
